/**
 * Portrait + background changer locale pack: it
 */

module.exports = {
  "portrait": {
    "overview": [
      "Miral AI Background Remover è gratuito dopo l’accesso e funziona bene per ritratti busto: foto LinkedIn, curriculum, avatar WeChat o Instagram e master trasparenti per foto tipo documento.",
      "Carica un JPG, PNG o WebP nitido fino a 15 MB. L’IA rileva la persona automaticamente. Prima di scaricare, ingrandisci ciuffi, occhiali, orecchini e la linea del collo.",
      "Un PNG trasparente non è una foto documento bianca o blu finita. Conserva prima il master trasparente, poi aggiungi il colore richiesto e ritaglia al formato ufficiale."
    ],
    "practice": [
      "Parto dall’originale della fotocamera quando posso. Le miniature delle chat e i filtri bellezza forti ammorbidiscono i capelli e rendono più difficile salvare le montature.",
      "Metto sempre il ritaglio su una tela chiara e una scura. Quel solo controllo rivela alone pallidi e ciuffi mancanti che in anteprima piccola sembrano a posto."
    ],
    "compareIntro": "Usa questa guida per le persone—avatar, foto tipo documento e headshot professionali. Usa la guida ecommerce per fondi bianchi prodotto e la guida di cambio sfondo quando vuoi una scena da caffè o ufficio dopo il ritaglio.",
    "workflow": "Carica un ritratto nitido fino a 15 MB, lascia che l’IA rimuova tutto lo sfondo, controlla capelli e occhiali, scarica un PNG trasparente e poi aggiungi bianco, blu o colore del brand.",
    "scenarioIntro": "Scegli il lavoro di ritratto più vicino al tuo e controlla i bordi che di solito falliscono in quel caso.",
    "sec": {
      "tldrTitle": "In sintesi",
      "tldrCols": [
        "Cosa ti serve",
        "Dettagli"
      ],
      "tldrRows": [
        [
          "Prezzo",
          "Miral AI Background Remover è gratuito dopo l’accesso"
        ],
        [
          "Upload",
          "JPG, PNG o WebP fino a 15 MB"
        ],
        [
          "Ideale per",
          "Headshot LinkedIn, foto CV, avatar, master foto documento"
        ],
        [
          "Download",
          "PNG trasparente; aggiungi bianco o blu dopo"
        ],
        [
          "Controlla da vicino",
          "Capelli, occhiali, orecchini, collo e spalle"
        ],
        [
          "Non questo articolo",
          "I fondi bianchi prodotto marketplace sono nella guida ecommerce"
        ]
      ],
      "tldrP": "Anche un selfie di strada o uno scatto frettoloso in ufficio può diventare un headshot pulito in Miral AI. Ritaglia una volta, conserva il file trasparente e solo allora crea la versione bianca, blu o brand di cui hai davvero bisogno.",
      "whatTitle": "Cosa servono ad avatar, foto documento e headshot LinkedIn",
      "whatP1": "I tre usi condividono il primo passo: ritaglia la persona con Miral AI Background Remover e conserva un PNG trasparente pulito. La differenza è il colore e il ritaglio aggiunti dopo.",
      "whatAvatarP": "Cosa risolve la rimozione dello sfondo dell’avatar: selfie in camera e scatti di strada seppelliscono il volto nel disordine. Rimuovi lo sfondo, metti il ritaglio su un colore brand o un tinta unita, poi anteprima il crop circolare per Instagram, WeChat o un sito personale.",
      "galleryAvatarCaption": "Esempio avatar: a sinistra un selfie interno disordinato; a destra il ritaglio su colore pieno pronto per un crop rotondo.",
      "whatIdP": "Cosa risolve la rimozione dello sfondo della foto documento: le domande spesso richiedono bianco o blu. Uno scatto del salotto di solito fallisce. Ritaglia una volta, aggiungi il colore richiesto e ritaglia al formato ufficiale. Ricontrolla sempre le regole attuali prima di inviare.",
      "galleryIdCaption": "Esempio foto documento: a sinistra uno sfondo domestico affollato; a destra la stessa persona su bianco puro per il ritaglio di misura.",
      "whatLinkedInP": "Cosa risolve il ritaglio LinkedIn: gli open space mettono monitor e colleghi dietro di te. Uno sfondo grigio o bianco calmo riporta l’attenzione su volto e abiti—la prima cosa che nota un recruiter.",
      "galleryLinkedInCaption": "Esempio LinkedIn: a sinistra un selfie da ufficio affollato; a destra il ritaglio su grigio soft pronto per un profilo da recruiter.",
      "whatTipTitle": "Un master trasparente per tutti e tre",
      "whatTipText": "Scarica prima il PNG trasparente. Deriva avatar colore brand, export documento bianco/blu e card LinkedIn grigio soft dallo stesso file.",
      "howTitle": "Quattro passi verso un headshot utilizzabile",
      "howP": "Apri Miral AI Background Remover, carica una foto busto, attendi il rilevamento automatico e ingrandisci al 100% capelli e occhiali prima di scaricare. Aggiungi bianco o blu solo quando il bordo è pulito.",
      "howTipTitle": "Preferisci il file originale",
      "howTipText": "I filtri bellezza forti e la compressione delle messaggistiche sfocano i ciuffi. L’originale della fotocamera vince quasi sempre.",
      "edgeTitle": "Dove i ritratti falliscono di solito",
      "edgeCols": [
        "Zona",
        "Errore comune",
        "Come controllare"
      ],
      "edgeRows": [
        [
          "Ciuffi volanti",
          "Cancellati come sfondo",
          "Vedi su tela scura e chiara"
        ],
        [
          "Occhiali",
          "Stanghetta mancante o buco nella lente",
          "Ingrandisci gli angoli della montatura"
        ],
        [
          "Orecchini / catenine sottili",
          "Linee metalliche spezzate",
          "Segui il bordo del gioiello"
        ],
        [
          "Collo e linea della giacca",
          "Alone bianco o spalla frastagliata",
          "Metti su tela scura"
        ],
        [
          "Barba o basette",
          "Peli lisciati via",
          "Riprova con meno ritocco sulla sorgente"
        ]
      ],
      "edgeP": "«Sembra a posto» in miniatura non basta. La revisione a dimensione piena su due colori di sfondo è il test di onestà più veloce.",
      "useTitle": "Avatar, LinkedIn, CV e foto tipo documento",
      "useCols": [
        "Uso",
        "Sfondo tipico",
        "Nota pratica"
      ],
      "useRows": [
        [
          "LinkedIn / siti di lavoro",
          "Grigio soft, bianco o blur pulito",
          "Mantieni il volto nitido; vincono gli sfondi calmi"
        ],
        [
          "Avatar WeChat / Instagram",
          "Colore brand o gradiente semplice",
          "Anteprima il crop circolare prima di pubblicare"
        ],
        [
          "Allegato CV",
          "Bianco o grigio chiaro",
          "Lascia spazio sopra la testa e sotto le spalle"
        ],
        [
          "Stampe tipo documento",
          "Bianco o blu",
          "Aggiungi il colore richiesto sul PNG trasparente, poi ritaglia"
        ],
        [
          "Passaporto / visto",
          "Segui le regole ufficiali attuali",
          "Colore, espressione e occhiali variano per paese"
        ],
        [
          "Copertine corso o live",
          "Colore brand o scena dopo",
          "Ritaglia pulito prima, poi progetta la copertina"
        ]
      ],
      "useTipTitle": "Le regole cambiano",
      "useTipText": "Le regole di visto ed esami differiscono per paese e anno. Lo strumento pulisce il soggetto; la conformità arriva dalla checklist ufficiale.",
      "hairTitle": "Ritaglio di capelli e occhiali",
      "hairItems": [
        "I ciuffi in controluce richiedono una sorgente più semplice e contrastata.",
        "Con gli occhiali, conferma che entrambe le stanghette e l’area delle lenti restino intatte.",
        "Capelli scuri su muro scuro sono un cattivo punto di partenza—avvicinati a un muro più chiaro se puoi.",
        "Maglione chiaro su muro bianco spesso perde la spalla; cambia lo sfondo di ripresa.",
        "Ricci lunghi e ciuffi dei bambini meritano uno zoom obbligatorio al 100% prima del download."
      ],
      "hairP": "Le grandi forme dei vestiti raramente rovinano un ritaglio di ritratto. Capelli e occhiali sì. È lì che spendo il minuto in più.",
      "troubleTitle": "Quando l’headshot sembra sbagliato",
      "troubleCols": [
        "Problema",
        "Causa probabile",
        "Prova questo"
      ],
      "troubleRows": [
        [
          "Pezzi di capelli mancanti",
          "Sorgente morbida, compressa o in controluce",
          "Usa un originale più nitido con meno bellezza"
        ],
        [
          "Bordo pallido su volto o spalle",
          "Vecchio colore di sfondo attaccato al bordo",
          "Conferma su tela scura, poi riprova con più contrasto"
        ],
        [
          "Montatura spezzata",
          "Riflessi forti confondono il contorno",
          "Rifai la foto con luce più morbida sulle lenti"
        ],
        [
          "I vestiti si fondono con il muro",
          "Basso contrasto soggetto/sfondo",
          "Cambia lo sfondo invece di rinviare lo stesso file"
        ],
        [
          "La foto documento sembra gialla",
          "Bilanciamento del bianco caldo",
          "Ritaglia prima, poi neutralizza il colore sul canvas finale"
        ]
      ],
      "troubleTipTitle": "Cambia l’input",
      "troubleTipText": "Rinviare lo stesso selfie soft raramente sistema i capelli. Una sorgente più pulita di solito sì.",
      "prosConsTitle": "Dove aiuta—e dove decidi ancora tu",
      "bestTitle": "Abitudini che rendono usabili gli avatar",
      "bestItems": [
        "Inquadratura busto con un po’ di spazio sopra i capelli.",
        "Espressione naturale; evita lo smoothing forte della pelle prima del ritaglio.",
        "Controlla il PNG su tele chiara e scura ogni volta.",
        "Salva master trasparente, export documento colorato e crop finale come file separati.",
        "Sulle piattaforme di lavoro, uno sfondo calmo rende più leggibili volto e abiti.",
        "Se poi ti serve un’atmosfera da caffè o ufficio, ritaglia pulito prima e segui la guida di cambio sfondo."
      ],
      "miralTitle": "Cosa fare dopo il ritaglio",
      "miralP": "In Miral AI puoi rafforzare il ritratto, costruire una card avatar calma o continuare in Seedream o FLUX.2 per una scena di copertina. Per la sostituzione lifestyle apri la guida di cambio sfondo IA. Per i bianchi prodotto usa la guida ecommerce.",
      "miralLinksTitle": "Prossimi passi utili",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "Guida al cambio sfondo IA",
          "path": "/hub/articles/ai-background-changer-online"
        },
        {
          "label": "Guida generale rimozione sfondo IA",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "Guida sfondo prodotto ecommerce",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        }
      ],
      "intentsTitle": "Flussi ritratto comuni",
      "faqTitle": "Domande prima del caricamento",
      "faqItems": [
        [
          "Come rimuovere gratis lo sfondo di un ritratto online?",
          "Accedi a Miral AI, carica un JPG, PNG o WebP busto e scarica il PNG trasparente."
        ],
        [
          "Come fare una foto documento bianca o blu da un selfie?",
          "Esporta prima un PNG trasparente, aggiungi il bianco o blu richiesto, ritaglia al formato ufficiale e ricontrolla le regole attuali prima di inviare."
        ],
        [
          "Come fare un headshot LinkedIn con rimozione sfondo?",
          "Rimuovi lo sfondo ufficio affollato, metti il ritaglio su grigio soft o bianco e conferma capelli e spalle prima dell’upload."
        ],
        [
          "Posso rimuovere gratis lo sfondo di un avatar WeChat o Instagram?",
          "Sì. Accedi, elabora l’originale dell’avatar e anteprima un crop circolare sul tuo colore brand."
        ],
        [
          "È possibile ritagliare online una foto con occhiali?",
          "Sì, ma ingrandisci montatura, stanghette e area lenti prima di scaricare."
        ],
        [
          "Quale strumento usare per il ritaglio dei capelli sui ritratti?",
          "Usa Miral AI Background Remover con l’originale della fotocamera e controlla i ciuffi su tele chiara e scura."
        ],
        [
          "Quale strumento per preparare lo sfondo di una foto passaporto?",
          "Crea prima un master ritratto trasparente, poi esporta colore e misura in millimetri ufficiali."
        ],
        [
          "Come sistemare un alone bianco dopo la rimozione dello sfondo del ritratto?",
          "Metti il PNG trasparente su una tela scura per trovare il bordo, poi riprova con un originale più nitido e contrastato."
        ],
        [
          "Come sistemare ciuffi mancanti su ricci o foto di bambini?",
          "Evita bellezza forte e miniature chat. Usa un originale più chiaro e rivedi al 100% prima del download."
        ],
        [
          "Posso elaborare tanti headshot professionali in batch?",
          "La pagina attuale elabora un’immagine alla volta così puoi controllare ogni bordo di capelli."
        ],
        [
          "Qual è la differenza tra sfondo documento trasparente e bianco?",
          "Un PNG trasparente può ricevere qualsiasi colore dopo. Un export bianco contiene già pixel bianchi per moduli e CV."
        ],
        [
          "Come cambiare poi lo sfondo in una scena da caffè o ufficio?",
          "Dopo che il PNG trasparente passa la revisione, segui la guida di cambio sfondo IA e verifica che la luce corrisponda."
        ]
      ]
    },
    "linksTitle": "Continua in Miral AI",
    "linksIntro": "Conserva il master ritratto trasparente, poi miglioralo, costruisci una card avatar o passa a una scena lifestyle.",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "Guida al cambio sfondo IA",
        "path": "/hub/articles/ai-background-changer-online"
      },
      {
        "label": "Guida generale rimozione sfondo IA",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "Guida sfondo prodotto ecommerce",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "Scegli una foto busto nitida",
        "text": "Usa un JPG, PNG o WebP fino a 15 MB con volto e spalle completamente visibili."
      },
      {
        "title": "Rimuovi lo sfondo automaticamente",
        "text": "Miral AI Background Remover rileva la persona e pulisce tutto lo sfondo—senza contorno manuale."
      },
      {
        "title": "Ispeziona capelli e occhiali",
        "text": "Ingrandisci ciuffi, montature, orecchini e la linea del collo."
      },
      {
        "title": "Scarica il PNG trasparente, poi aggiungi colore",
        "text": "Conserva il master, poi aggiungi bianco, blu, grigio o colore brand per l’uso finale."
      }
    ],
    "pros": [
      "Pensato per i bordi ritratto usati in avatar e foto tipo documento",
      "Niente strumento penna di Photoshop per i capelli",
      "Un PNG trasparente può diventare tanti colori di sfondo",
      "Elaborazione gratuita nel browser dopo l’accesso"
    ],
    "cons": [
      "I capelli fini richiedono ancora una revisione a dimensione piena",
      "Controluce o basso contrasto possono ammorbidire i bordi",
      "Un’immagine alla volta sulla pagina attuale",
      "Le regole ufficiali documento richiedono ancora un controllo manuale"
    ],
    "tips": [
      {
        "title": "Controlla due colori di tela",
        "text": "Sfondi chiaro e scuro rivelano rapidamente alone e ciuffi mancanti."
      },
      {
        "title": "Proteggi occhiali e gioielli",
        "text": "Ingrandisci stanghette, angoli delle lenti e catenine sottili prima di scaricare."
      },
      {
        "title": "Separa master ed export documento",
        "text": "Non sovrascrivere il PNG trasparente con un file bianco o blu appiattito."
      },
      {
        "title": "Tieni i filtri leggeri",
        "text": "La bellezza forte ammorbidisce i bordi esatti di cui il modello ha bisogno."
      },
      {
        "title": "Sai quale guida aprire dopo",
        "text": "Sostituzione scena → cambio sfondo. Bianchi prodotto → guida ecommerce."
      }
    ],
    "scenarios": [
      {
        "title": "Rimozione sfondo headshot LinkedIn",
        "text": "Ritaglia un busto nitido e mettilo su grigio soft o bianco prima dell’upload."
      },
      {
        "title": "Ritaglio avatar WeChat o Instagram",
        "text": "Scarica un PNG trasparente e anteprima il crop circolare sul tuo colore brand."
      },
      {
        "title": "Foto CV con sfondo bianco",
        "text": "Conserva il master trasparente ed esporta un file sfondo bianco separato per il PDF."
      },
      {
        "title": "Foto tipo documento sfondo blu",
        "text": "Aggiungi il blu richiesto solo quando il bordo dei capelli è pulito."
      },
      {
        "title": "Rimuovere lo sfondo intorno ai capelli online",
        "text": "Usa l’originale della fotocamera e controlla i ciuffi su tele chiara e scura."
      },
      {
        "title": "Ritaglio ritratto con occhiali",
        "text": "Ingrandisci angoli della montatura e stanghette prima di fidarti del download."
      },
      {
        "title": "Preparazione foto passaporto",
        "text": "Crea prima il PNG trasparente, poi segui misura e colore attuali del paese."
      },
      {
        "title": "Da selfie ufficio a headshot professionale",
        "text": "Rimuovi il disordine del corridoio, mantieni espressione naturale, evita filtri forti."
      },
      {
        "title": "Ritaglio bambini o capelli ricci",
        "text": "Aspettati più ciuffi; rivedi sempre al 100%."
      },
      {
        "title": "Sfondo ritratto trasparente vs bianco",
        "text": "Il trasparente resta riutilizzabile; il bianco è un export appiattito per un modulo specifico."
      },
      {
        "title": "Sistemare alone bianco su un ritaglio volto",
        "text": "Conferma il bordo su tela scura, poi riprova con più contrasto sulla sorgente."
      },
      {
        "title": "Dal ritaglio ritratto a una scena da caffè",
        "text": "Usa la guida di cambio sfondo dopo che il PNG trasparente passa la revisione."
      }
    ],
    "toolFaq": [
      {
        "q": "Come rimuovere gratis lo sfondo di un ritratto online?",
        "a": "Accedi, carica un ritratto e scarica il PNG trasparente senza software desktop."
      },
      {
        "q": "Come fare una foto documento bianca o blu da un selfie?",
        "a": "Rimuovi lo sfondo, conserva il PNG trasparente, aggiungi il colore richiesto e ritaglia al formato ufficiale."
      },
      {
        "q": "Posso rimuovere gratis lo sfondo di un avatar WeChat o Instagram?",
        "a": "Sì. Elabora l’originale dopo l’accesso e anteprima il crop circolare sul tuo colore brand."
      },
      {
        "q": "È possibile ritagliare online una foto con occhiali?",
        "a": "Sì, ma controlla stanghette e aree lenti a dimensione piena prima di scaricare."
      },
      {
        "q": "Quale strumento usare per il ritaglio dei capelli sui ritratti?",
        "a": "Usa Miral AI Background Remover con un originale nitido e ispeziona i ciuffi su tele chiara e scura."
      },
      {
        "q": "Quale strumento per preparare lo sfondo di una foto passaporto?",
        "a": "Crea prima un master ritratto trasparente, poi esporta colore e misura richiesti dal modulo."
      },
      {
        "q": "Come sistemare un alone bianco dopo la rimozione dello sfondo del ritratto?",
        "a": "Conferma il bordo su tela scura, poi riprova con una sorgente più nitida e contrastata."
      },
      {
        "q": "Come sistemare ciuffi mancanti su ricci o foto di bambini?",
        "a": "Evita bellezza forte e miniature chat; usa un originale più chiaro e rivedi al 100%."
      },
      {
        "q": "Posso elaborare tanti headshot professionali in batch?",
        "a": "La pagina attuale gestisce un’immagine alla volta."
      },
      {
        "q": "Come cambiare poi lo sfondo in una scena da caffè?",
        "a": "Usa il PNG trasparente revisionato con il flusso di cambio sfondo IA."
      }
    ]
  },
  "changer": {
    "overview": [
      "Il cambio sfondo funziona meglio in due passaggi: rimozione gratuita verso un PNG trasparente pulito, poi posizionamento in una nuova scena—luce da caffè, ufficio tranquillo, muro brand o luce diurna outdoor.",
      "Miral AI Background Remover gestisce il ritaglio. Seedream o FLUX.2 possono costruire scene lifestyle dopo. Non confonderlo con lastre prodotto bianco puro stile Amazon; quel flusso è nella guida ecommerce.",
      "Se il ritaglio ha ancora un bordo pallido, ogni nuova scena sembrerà falsa. Sistema prima i bordi, poi l’atmosfera."
    ],
    "practice": [
      "Rifiuto di comporre finché il soggetto trasparente non è pulito su una tela chiara e una scura.",
      "Allineo la direzione della luce prima del «bello». Un ritratto con luce finestra su una strada neon notturna raramente inganna."
    ],
    "compareIntro": "Usa la rimozione sfondo per il master trasparente, questa guida per scene lifestyle o cover, la guida ritratto per colori tipo documento e la guida ecommerce per fondi bianchi marketplace.",
    "workflow": "Ritaglia il soggetto, scegli una scena allineata all’illuminazione, componi o genera il nuovo ambiente, poi controlla ombre di contatto, temperatura colore e bordi prima dell’export.",
    "scenarioIntro": "Scegli prima l’obiettivo della scena e tieni il master trasparente separato da ogni crop finale.",
    "sec": {
      "tldrTitle": "L’ordine che funziona davvero",
      "tldrCols": [
        "Passo",
        "Conservare",
        "Attenzione"
      ],
      "tldrRows": [
        [
          "1. Rimuovi sfondo",
          "Master PNG trasparente Miral AI",
          "I vecchi alone rovinano ogni scena successiva"
        ],
        [
          "2. Scegli scena",
          "Caffè, ufficio, muro brand, outdoor",
          "Scegli per il lavoro, non per estetica a caso"
        ],
        [
          "3. Componi o genera",
          "Immagine lifestyle o cover",
          "Allinea direzione luce e temperatura"
        ],
        [
          "4. Rivedi",
          "Export pronto da pubblicare",
          "Bordi, scala e senso di contatto"
        ],
        [
          "Separa dalle lastre bianche",
          "Guida ecommerce per SKU bianchi",
          "Questo articolo è per sostituzione scena"
        ]
      ],
      "tldrP": "Cambiare uno sfondo non è un filtro magico unico. In Miral AI isoli il soggetto con Background Remover e poi gli dai un nuovo posto. Salta il primo lavoro e il secondo sembra quasi sempre appiccicato.",
      "removeTitle": "Immagini lifestyle, cover social e poster evento richiedono ciascuno una lastra diversa",
      "removeP1": "I vecchi colori del muro si attaccano a capelli e bordi della giacca. Il percorso stabile resta lo stesso: Miral AI Background Remover → master PNG trasparente → nuova scena per il lavoro. Le lastre prodotto bianche marketplace sono nella guida ecommerce, non qui.",
      "removeLifestyleP": "Cosa risolve il cambio lifestyle: luce da caffè, posti finestra e angoli di casa creano atmosfera—ma uno sfondo originale disordinato rende tutto economico. Ritaglia pulito e metti la persona in una scena la cui luce coincide con il volto.",
      "galleryLifestyleCaption": "Esempio lifestyle: a sinistra il master trasparente; a destra la stessa persona composta in una scena da caffè luminosa.",
      "removeSocialP": "Cosa risolve il cambio cover social: Instagram, Xiaohongshu e header LinkedIn servono un volto chiaro e spazio per un titolo. Una camera disordinata o un open space riempiono il frame. Un gradiente brand o un muro di colore calmo mette la persona da un lato e lascia l’altro per il testo.",
      "gallerySocialCaption": "Esempio cover social: a sinistra il master trasparente; a destra un muro a gradiente brand con spazio per un titolo.",
      "removePosterP": "Cosa risolve il cambio poster evento: webinar, lanci corso e annunci talk servono un palco o muro brand calmo—non un selfie da scrivania. Dopo il ritaglio, metti la persona su una lastra brand soft con spazio per il titolo, poi aggiungi testo in GPT Image se serve.",
      "galleryPosterCaption": "Esempio poster evento: a sinistra il master trasparente; a destra un muro brand soft adatto a una cover di talk o corso.",
      "removeTipTitle": "Separa master, scena e crop di cover",
      "removeTipText": "Non sovrascrivere il PNG trasparente con un solo export caffè o gradiente. Il poster della stagione successiva deve riusare lo stesso ritaglio.",
      "howTitle": "Un workflow online pratico",
      "howP": "Apri Miral AI Background Remover e ottieni prima un soggetto trasparente affidabile. Poi scegli il tipo di sfondo: tinta unita è il più veloce, lastra foto reale il successivo, ambiente generato IA il più flessibile. Prima dell’export, verifica se la persona sembra ancora illuminata dallo stesso mondo dello sfondo.",
      "howTipTitle": "La luce batte la decorazione",
      "howTipText": "Uno sfondo più calmo con luce allineata batte una scena drammatica che combatte il volto.",
      "sceneTitle": "Idee di scena che tendono a funzionare",
      "sceneCols": [
        "Direzione",
        "Buono per",
        "Attenzione"
      ],
      "sceneRows": [
        [
          "Caffè luminoso / posto finestra",
          "Brand personale e cover lifestyle",
          "Le lampadine calde possono spingere la pelle troppo arancio"
        ],
        [
          "Ufficio tranquillo / libreria soft blur",
          "LinkedIn e immagini mentor di corso",
          "I props di sfondo devono restare più calmi del volto"
        ],
        [
          "Luce diurna outdoor e verde",
          "Viaggi, wellness, post lifestyle",
          "Evita un zenith duro di mezzogiorno che combatte l’originale"
        ],
        [
          "Muro brand pieno o gradiente soft",
          "Poster evento e header social",
          "Mantieni contrasto sufficiente per testo overlay"
        ],
        [
          "Illuminazione palco o keynote",
          "Annunci talk",
          "I flare non devono tagliare il volto"
        ],
        [
          "Angolo lifestyle casa",
          "Storytelling prodotto soft",
          "Mantieni prospettiva e scala della persona coerenti"
        ]
      ],
      "sceneP": "Ciò che funziona spesso significa chiaro, non affollato. Una persona pulita su uno sfondo calmo e intenzionale di solito batte un collage impegnato.",
      "qualityTitle": "Cinque posti dove si vede il falso",
      "qualityItems": [
        "Capelli e spalle: frange bianche o colorate della stanza precedente.",
        "Direzione luce: highlight del volto e luce finestra devono coincidere.",
        "Temperatura colore: pelle di interno calda su lastra blu fredda sembra spezzata.",
        "Scala: la persona non deve galleggiare come uno sticker né restringersi nella profondità sbagliata.",
        "Contatto: un accenno di suolo o sedia rende credibile la composizione."
      ],
      "qualityTipTitle": "Anteprima il crop presto",
      "qualityTipText": "Controlla un crop avatar quadrato e uno cover largo prima di impegnarti sulla scena finale.",
      "vsTitle": "Come questo articolo si separa dagli altri",
      "vsCols": [
        "Guida",
        "Lavoro principale",
        "Aprila quando"
      ],
      "vsRows": [
        [
          "Rimozione sfondo IA generale",
          "Qualsiasi soggetto → PNG trasparente",
          "Ti serve solo il ritaglio"
        ],
        [
          "Sfondo prodotto ecommerce",
          "Lastre prodotto bianche / trasparenti",
          "Conformità Amazon, Shopify"
        ],
        [
          "Rimozione sfondo ritratto",
          "Avatar e colori tipo documento",
          "Volti, capelli, master bianco/blu"
        ],
        [
          "Cambio sfondo IA (questo)",
          "Sostituzione scena dopo ritaglio",
          "Atmosfera caffè, ufficio, muro brand"
        ]
      ],
      "vsP": "Collega le quattro guide, ma tieni le keyword oneste. Le lastre prodotto bianche non appartengono a un articolo lifestyle, e le foto documento blu visto non appartengono a un pitch di composizione caffè.",
      "troubleTitle": "Quando la nuova scena sembra sbagliata",
      "troubleCols": [
        "Problema",
        "Causa",
        "Correzione"
      ],
      "troubleRows": [
        [
          "Frangia chiara intorno al soggetto",
          "Ritaglio ancora sporco",
          "Torna alla rimozione con un originale più contrastato"
        ],
        [
          "Sembra uno sticker",
          "Contatto mancante o luce disallineata",
          "Ammorbidisci la lastra o aggiungi un’ombra di contatto molto leggera"
        ],
        [
          "Pelle grigia o arancio",
          "Scontro di temperatura colore",
          "Scegli una scena di temperatura più vicina o unifica il grade"
        ],
        [
          "Capelli sporchi",
          "Alpha incompleto intorno ai ciuffi",
          "Pulisci il ritaglio prima di ricomporre"
        ],
        [
          "La forma prodotto deriva in una scena IA",
          "La generazione ha cambiato l’oggetto",
          "Blocca l’identità; lascia che l’IA inventi solo l’ambiente"
        ]
      ],
      "prosConsTitle": "Cosa sblocca questo workflow",
      "bestTitle": "Sostituzioni che reggono sullo schermo del telefono",
      "bestItems": [
        "Non saltare mai il master trasparente pulito.",
        "Lascia che il canale decida la scena: recruiting resta calmo, lifestyle può respirare, poster servono spazio titolo.",
        "Un’illuminazione sorgente semplice facilita la sostituzione.",
        "Anteprima sempre a dimensione telefono prima di pubblicare.",
        "Aggiungi il testo del titolo dopo che la scena funziona—GPT Image può aiutare con tipografia poster.",
        "Invia gli SKU bianchi marketplace alla guida ecommerce per separare le intenzioni."
      ],
      "miralTitle": "Tieni la catena dentro Miral AI",
      "miralP": "Percorso suggerito in Miral AI: Background Remover → Image Enhancer opzionale → Seedream o FLUX.2 per l’ambiente → GPT Image se serve tipografia poster. Per card tipo documento bianche o blu, torna alla guida ritratto.",
      "miralLinksTitle": "Prossimi passi utili",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "Guida ritratto e foto tessera",
          "path": "/hub/articles/ai-portrait-background-remover"
        },
        {
          "label": "Guida generale rimozione sfondo IA",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "Guida sfondo prodotto ecommerce",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        },
        {
          "label": "GPT Image 1.5",
          "path": "/image-models/gpt-image-ai-image-generator"
        }
      ],
      "intentsTitle": "Lavori comuni di cambio sfondo",
      "faqTitle": "Domande pratiche",
      "faqItems": [
        [
          "Come cambiare gratis lo sfondo di una foto online?",
          "Accedi a Miral AI, esporta un PNG trasparente con Background Remover e metti il soggetto su un caffè, muro brand o nuova scena."
        ],
        [
          "Come fare un’immagine lifestyle da un PNG trasparente?",
          "Componi su una lastra con luce allineata, controlla contatto e temperatura, e separa master e crop di cover."
        ],
        [
          "Come cambiare lo sfondo di una cover social dopo il ritaglio?",
          "Dopo che i bordi dei capelli passano la revisione, metti il soggetto su un lato di un gradiente brand e lascia spazio per il titolo."
        ],
        [
          "Posso sostituire lo sfondo di un selfie con una scena da caffè?",
          "Sì. Ritaglia pulito prima, poi componi in una lastra caffè la cui luce finestra coincide con il volto."
        ],
        [
          "È possibile generare una nuova scena IA dietro una persona reale?",
          "Sì. Conserva il soggetto reale del PNG trasparente e lascia che Seedream o FLUX.2 inventino solo l’ambiente."
        ],
        [
          "Quale strumento per sostituire lo sfondo di un poster evento?",
          "Usa Miral AI Background Remover per il ritaglio, mettilo su un muro brand soft e aggiungi il titolo in GPT Image se serve."
        ],
        [
          "Quale strumento per sostituire lo sfondo di una cover social?",
          "Background Remover più un muro colore brand o gradiente. Continua in Seedream o FLUX.2 quando serve una scena lifestyle più completa."
        ],
        [
          "Come sistemare una composizione di sfondo che sembra falsa?",
          "Ispeziona frangia, direzione luce e temperatura in quest’ordine. Se i bordi sono sporchi, torna prima alla rimozione sfondo."
        ],
        [
          "Come sistemare un disallineamento di luce diurna outdoor cambiando sfondi?",
          "Allinea la direzione del sole; evita uno zenith duro di mezzogiorno su un volto illuminato per interni."
        ],
        [
          "Posso usare il cambio sfondo per una cover video?",
          "Sì. Esporta il crop al ratio della cover e tieni il soggetto nell’area sicura."
        ],
        [
          "Qual è la differenza tra rimozione e cambio sfondo?",
          "La rimozione dà un soggetto trasparente. Il cambio mette quel soggetto in una nuova scena o colore."
        ],
        [
          "Posso usare questo per fondi prodotto bianchi Amazon?",
          "No. Le lastre bianche marketplace sono nella guida ecommerce; questo articolo è per scene lifestyle e cover."
        ]
      ]
    },
    "linksTitle": "Costruisci il workflow di scena in Miral AI",
    "linksIntro": "Ritaglia una volta, conserva il master trasparente e crea scene lifestyle, cover o lastre poster senza rifare la maschera.",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "Guida ritratto e foto tessera",
        "path": "/hub/articles/ai-portrait-background-remover"
      },
      {
        "label": "Guida generale rimozione sfondo IA",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "Guida sfondo prodotto ecommerce",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      },
      {
        "label": "GPT Image 1.5",
        "path": "/image-models/gpt-image-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "Ritaglia prima un soggetto pulito",
        "text": "Usa Miral AI Background Remover per scaricare un PNG trasparente e confermare bordi di capelli o prodotto."
      },
      {
        "title": "Decidi la sensazione della nuova scena",
        "text": "Caffè, ufficio tranquillo, luce diurna outdoor o muro brand—scegli per il canale."
      },
      {
        "title": "Metti il soggetto nel nuovo sfondo",
        "text": "Componi su un canvas di design o continua in Seedream / FLUX.2 con luce allineata."
      },
      {
        "title": "Controlla luce, scala e contatto",
        "text": "Cerca frange, scontro di colore, dimensione sbagliata e contatto mancante."
      },
      {
        "title": "Esporta il crop di cui hai bisogno",
        "text": "Salva dimensioni cover e avatar separatamente e lascia intatto il master trasparente."
      }
    ],
    "pros": [
      "Un master trasparente supporta tante scene",
      "Più economico che rifotografare ogni ambiente",
      "Ottimo per cover social e frame lifestyle",
      "Si collega in modo pulito al lavoro di scena Seedream e FLUX.2"
    ],
    "cons": [
      "Una luce disallineata si legge falsa subito",
      "Bordi di ritaglio sporchi rovinano tutta la composizione",
      "Gli SKU bianchi marketplace devono usare la guida ecommerce",
      "Scene di prospettiva complesse possono ancora richiedere rifinitura manuale"
    ],
    "tips": [
      {
        "title": "Bordi prima dell’atmosfera",
        "text": "Non comporre mai un ritaglio che mostra ancora un alone su tela scura."
      },
      {
        "title": "Allinea prima la luce",
        "text": "Scegli lastre la cui luce chiave coincide con volto o prodotto."
      },
      {
        "title": "Separa i master",
        "text": "PNG trasparente, export lifestyle e crop social devono essere file diversi."
      },
      {
        "title": "Lascia spazio al testo",
        "text": "Gli sfondi poster servono zone più calme dove possa stare un titolo."
      },
      {
        "title": "Separa le intenzioni di ricerca",
        "text": "Invia le lastre bianche Amazon all’articolo ecommerce; tieni questo per il cambio scena."
      }
    ],
    "scenarios": [
      {
        "title": "Sostituire gratis lo sfondo foto online",
        "text": "Ritaglia prima il soggetto e mettilo su una nuova lastra o scena generata."
      },
      {
        "title": "Sfondo lifestyle caffè per ritratto",
        "text": "Usa una lastra con luce finestra che coincide con l’illuminazione del volto."
      },
      {
        "title": "Sfondo ufficio per foto professionale",
        "text": "Mantieni scaffali e props più soft della persona."
      },
      {
        "title": "Sfondo colore brand per cover social",
        "text": "PNG trasparente su tinta unita o gradiente soft con spazio per il titolo."
      },
      {
        "title": "Cambiare sfondo dopo ritaglio IA",
        "text": "Non comporre finché capelli e bordi giacca non passano un controllo a due tele."
      },
      {
        "title": "Scena IA generata dietro una persona reale",
        "text": "Lascia che Seedream o FLUX.2 inventino la stanza, non un nuovo volto o outfit."
      },
      {
        "title": "Sostituzione sfondo poster evento",
        "text": "Preferisci muri brand puliti così il titolo resta leggibile."
      },
      {
        "title": "Swap sfondo luce diurna outdoor",
        "text": "Allinea la direzione del sole; evita zenith di mezzogiorno su un volto soft da interno."
      },
      {
        "title": "Sistemare una composizione di sfondo falsa",
        "text": "Ispeziona frangia, direzione luce e temperatura in quest’ordine."
      },
      {
        "title": "Da PNG trasparente a immagine lifestyle",
        "text": "Archivia il master, esporta i crop di cover separatamente."
      },
      {
        "title": "Non per fondi bianchi Amazon",
        "text": "Invia le lastre listing alla guida prodotto ecommerce."
      },
      {
        "title": "Ritaglio ritratto poi cambio scena",
        "text": "Finisci la revisione capelli nel workflow ritratto, poi apri questo workflow di scena."
      }
    ],
    "toolFaq": [
      {
        "q": "Come cambiare gratis lo sfondo di una foto online?",
        "a": "Accedi, rimuovi lo sfondo originale a un PNG trasparente e metti il soggetto su una nuova scena o tinta unita."
      },
      {
        "q": "Come fare un’immagine lifestyle da un PNG trasparente?",
        "a": "Componi su una lastra a luce allineata, controlla contatto e temperatura, e separa il master dai crop di cover."
      },
      {
        "q": "Posso sostituire lo sfondo di un selfie con una scena da caffè?",
        "a": "Sì. Ritaglia prima la persona e componi in una lastra caffè con luce finestra simile."
      },
      {
        "q": "È possibile generare una nuova scena IA dietro una persona reale?",
        "a": "Sì. Conserva il soggetto reale e lascia che Seedream o FLUX.2 creino solo l’ambiente."
      },
      {
        "q": "Quale strumento per sostituire lo sfondo di un poster evento?",
        "a": "Usa Background Remover per il ritaglio, mettilo su un muro brand calmo e aggiungi il titolo se serve."
      },
      {
        "q": "Quale strumento per sostituire lo sfondo di una cover social?",
        "a": "Background Remover più muro colore brand o gradiente; continua in Seedream o FLUX.2 per scene lifestyle più ricche."
      },
      {
        "q": "Come sistemare una composizione di sfondo che sembra falsa?",
        "a": "Pulisci la frangia, allinea la direzione luce e unifica la temperatura prima dell’export."
      },
      {
        "q": "Come sistemare un disallineamento di luce diurna outdoor cambiando sfondi?",
        "a": "Allinea la direzione del sole ed evita zenith di mezzogiorno su un volto illuminato per interni."
      },
      {
        "q": "Posso usare il cambio sfondo per una cover video?",
        "a": "Sì. Esporta il crop al ratio cover e tieni il soggetto nell’area sicura."
      },
      {
        "q": "Posso usare questo per fondi prodotto bianchi Amazon?",
        "a": "No. Usa la guida sfondo prodotto ecommerce per lastre bianche marketplace."
      }
    ]
  },
  "articles": {
    "ai-portrait-background-remover": {
      "title": "Rimozione sfondo ritratto IA gratuita per headshot, avatar e foto documento",
      "excerpt": "Trasforma un selfie affollato in un headshot pulito: rimuovi gratis lo sfondo del ritratto, esporta un PNG trasparente e aggiungi bianco, blu o colore brand per LinkedIn, CV e avatar.",
      "metaTitle": "Rimozione sfondo ritratto IA gratuita | Miral",
      "metaDescription": "Rimuovi gratis gli sfondi ritratto con Miral AI. Conserva il dettaglio dei capelli, esporta PNG trasparenti e crea headshot LinkedIn o foto tipo documento bianche e blu.",
      "target": {
        "label": "Apri rimozione sfondo ritratto",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "rimozione sfondo ritratto gratis",
        "ritaglio headshot IA",
        "sfondo foto LinkedIn",
        "sfondo foto documento",
        "rimozione sfondo avatar",
        "rimuovere sfondo intorno ai capelli",
        "foto CV sfondo bianco",
        "foto documento sfondo blu online"
      ]
    },
    "ai-background-changer-online": {
      "title": "Cambio sfondo IA gratuito: scene di vita, cover social e poster evento",
      "excerpt": "Rimuovi gratis lo sfondo vecchio e metti persone in scene di vita da caffè, cover a gradiente brand o muri da poster—senza competere con l’intento fondo bianco ecommerce.",
      "metaTitle": "Cambio sfondo IA gratuito online | Miral",
      "metaDescription": "Cambia sfondi foto online con Miral AI: ritaglia in PNG trasparente e crea scene di vita da caffè, cover social e poster evento.",
      "target": {
        "label": "Apri rimozione sfondo IA",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "cambio sfondo IA gratis",
        "sostituire sfondo foto online",
        "cambiare sfondo dopo ritaglio",
        "sostituzione scena IA",
        "cambio sfondo lifestyle",
        "sfondo caffè per ritratto",
        "sostituzione sfondo cover social",
        "PNG trasparente nuovo sfondo"
      ]
    }
  }
}
